import { useState } from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';
import CCIconClose8x8 from '../../../libs/CiscoCore/Icon/Close/8x8';

const PartnerMap = withScriptjs(withGoogleMap(
  props => {
    const coordinates = 'loc_coordinates' in props.partnerDetails &&
          !!props.partnerDetails.loc_coordinates &&
          !!props.partnerDetails.loc_coordinates.length ?
      props.partnerDetails.loc_coordinates.split(",") :
      ['0.0', '0.0'];

    const [latitude, setLatitude] = useState(parseFloat(coordinates[0]));
    const [longitude, setLongitude] = useState(parseFloat(coordinates[1]));
    const partnerAddress = [
      !!props.partnerDetails.site_addr_1?props.partnerDetails.site_addr_1:'',
      !!props.partnerDetails.site_addr_2?props.partnerDetails.site_addr_2:'',
      !!props.partnerDetails.site_addr_3?props.partnerDetails.site_addr_3:'',
      `${!!props.partnerDetails.site_city?props.partnerDetails.site_city+', ':''}${!!props.partnerDetails.site_zip?props.partnerDetails.site_zip:''} ${!!props.partnerDetails.site_state?props.partnerDetails.site_state:''}`.trim(),
      props.partnerDetails.site_country
    ].filter((addressElement) => !!addressElement.length);

    const [isInfoBoxOpened, setIsInfoBoxOpened] = useState(false);
    const toggleInfoBox = () => { setIsInfoBoxOpened(!isInfoBoxOpened) };

    return (
      <GoogleMap defaultZoom={11}
                 defaultCenter={{ lat: latitude, lng: longitude }}>
        <Marker defaultTitle={props.partnerDetails.partner_name}
                position={{ lat: latitude, lng: longitude }}
                onClick={toggleInfoBox}>
          {
            isInfoBoxOpened &&
            <InfoBox
              options={
                {
                  disableAutoPan:false,
                  zIndex: null,
                  defaultPosition: new window.google.maps.LatLng(latitude, longitude),
                  pixelOffset: new window.google.maps.Size(-100, -136),
                  enableEventPropagation: true,
                  boxStyle: {
                    zIndex: 999,
                    width: '200px',
                  },
                  closeBoxURL: ''
                }
              }
            >
              <div className="relative shadow-cc-lg relative p-2 font-normal tracking-wide text-cc-primary-contrast bg-cc-primary text-cc-body-small rounded border border-cc-gray-40">
                <button className="appearance-none absolute top-1 right-1 text-cc-body-small rounded-full bg-cc-white ml-2 mb-2 pl-2 pb-2" onClick={toggleInfoBox}><CCIconClose8x8 className=""/></button>
                <p className="font-semibold mb-0.5 mr-2 truncate">{props.partnerDetails.partner_name}</p>
                <p className="text-cc-gray-80 text-cc-body-small font-normal mb-1 mr-2 truncate">{props.partnerDetails.site_name}</p>
                {
                  partnerAddress.map((addressElement,index) => <p className="text-cc-body-small" key={index}>{addressElement}</p>)
                }
              </div>
            </InfoBox>
          }
        </Marker>
      </GoogleMap>
    )
  }
));

export default (PartnerMap);
